import { useEffect, useState } from "react"
import axios from "axios";

export const useLocation = () => {
    const geolocationAPI = navigator.geolocation;
    const [ locationData, setLocationData ] = useState();

    const [ geoPosition, setGeoPosition ] = useState({
        lat: '', long: ''
    });
    
    const getGeolocation = () => {
        if(geolocationAPI){
            geolocationAPI.getCurrentPosition((position) => {
                const { coords } = position;
                setGeoPosition({
                    lat: coords.latitude, long: coords.longitude
                })
                console.log(coords);
            }, (error) => {
                console.error("Error Code = " + error.code + " - " + error.message);
            });
        }
    }

    const getLocationData = () => {
        const endpoint = 'https://ipgeolocation.abstractapi.com/v1/';
        const apiKey = 'ac4a8dc8b1a443ef9b3393a889c52458';
        try {
            axios.get(`${endpoint}?api_key=${apiKey}`).then(res => {
                const data = res.data;
                setGeoPosition({
                    lat: data.latitude, long: data.longitude
                })
                setLocationData(data);
            });
        } catch (err) {
            console.log(err.message)
        }
    };

    useEffect(() => {
        getGeolocation();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [geolocationAPI])

    useEffect(() => {
        if (!locationData){
            getLocationData();
        }
    }, [locationData])

    return { geoPosition, locationData, getLocationData };
}